module.exports = __webpack_public_path__ + "89d6f549c2557e50bf7a898b2334aaeb.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/fi-2010.png
// module id = 521
// module chunks = 0